/**
 * Délais pour le chat assistant (stream SSE).
 * Augmenter si les réponses longues (listes, analyses) sont coupées.
 */
export const AI_CHAT_FETCH_ABORT_MS = 120_000;
/** Marge après abort pour débloquer l’UI si le navigateur ne ferme pas la connexion. */
export const AI_CHAT_HARD_STOP_MS = AI_CHAT_FETCH_ABORT_MS + 30_000;
/**
 * Côté serveur : temps max avant la première réponse du LLM (connexion + premier chunk).
 * Une fois le stream démarré, le timeout est levé ; la génération peut continuer.
 */
export const AI_CHAT_STREAM_START_TIMEOUT_MS = 120_000;

export function aiChatTimeoutMessage(): string {
  const s = Math.round(AI_CHAT_FETCH_ABORT_MS / 1000);
  return `L'IA n'a pas répondu dans le délai imparti (${s}s). Vérifiez Paramètres > IA ou réessayez.`;
}
